import React from 'react';
import { TouchableOpacity, StyleSheet, ViewStyle } from 'react-native';
import { PlayCircle } from 'lucide-react-native';
import { useCurrentTheme } from '@/theming/useCurrentTheme';
import { ThemeType } from '@/theming/baseTheme';

interface PlayButtonProps {
    onPress?: () => void;
    size?: number;
    style?: ViewStyle;
    disabled?: boolean;
}

export const PlayButton: React.FC<PlayButtonProps> = ({
                                                          onPress,
                                                          size = 48,
                                                          style,
                                                          disabled = false,
                                                      }) => {
    const { theme } = useCurrentTheme();
    const styles = createStyles(theme, size);

    return (
        <TouchableOpacity
            style={[styles.playButton, style]}
            onPress={onPress}
            activeOpacity={0.7}
            disabled={disabled}
        >
            <PlayCircle
                size={size}
                color={theme.colors.primary}
                fill={theme.colors.surface}
            />
        </TouchableOpacity>
    );
};

const createStyles = (theme: ThemeType, size: number) => StyleSheet.create({
    playButton: {
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: size / 2,
        backgroundColor: 'transparent',
    },
});
